// @flow

import { REQUEST_TYPES } from '.';

export const checkAccountRecoveryEmailRequest = (
  email: string
): RequestOptions => ({
  type: '[API] Account Recovery Check Email',
  url: `/user/ui/phoneExists/${email}`,
  APIMethod: REQUEST_TYPES.GET,
});

export const accountVerifyRequest = (body: Object): RequestOptions => ({
  type: '[API] Account Recovery Account Verify',
  url: '/user/ui/accountVerify',
  APIMethod: REQUEST_TYPES.POST,
  body,
});

export const accountDeactivateRequest = (body: Object): RequestOptions => ({
  type: '[API] Account Recovery Account Deactivate',
  url: '/user/ui/accountDeactivate',
  APIMethod: REQUEST_TYPES.POST,
  body,
});
